/**
 *
 * EmptyButton
 *
 */

import React from "react"
import { Button } from "antd"
// import PropTypes from 'prop-types';
import "./index.less"

const EmptyButton = (props) => {
  return (
    <Button {...props} className="button">
      {props.label}
    </Button>
  )
}

EmptyButton.propTypes = {}

export default EmptyButton
